import { UniversalNoPictureCard } from '@components/core-ui/UniversalNoPictureCard';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { useQuery } from '@tanstack/react-query';
import { billingKeys } from 'app/queries/billing/billingKeys';
import { createFetchMemberPaymentMethodsQueryFn } from 'app/queries/billing/createFetchMemberPaymentMethodsQueryFn';
import { useNavigate } from 'react-router';
import { getPaymentMethodSummary } from './helpers/getPaymentMethodSummary';

export const BillingAccountCard = () => {
  const navigate = useNavigate();
  const { call } = useAPI();
  const { organization } = useAuthContext();
  const baId = organization?.billingAccount.id ?? '';

  const paymentMethodsQuery = useQuery({
    queryKey: billingKeys.memberPaymentMethodsByAccount(baId),
    queryFn: createFetchMemberPaymentMethodsQueryFn(call),
    enabled: baId !== '',
  });

  const getPaymentInfo = () => {
    if (paymentMethodsQuery.data !== undefined) {
      return getPaymentMethodSummary(paymentMethodsQuery.data ?? []);
    }
    if (paymentMethodsQuery.isError) {
      return 'Failed to load payment method.';
    }
    return '...';
  };

  const handleBillingAccountDetailsClick = () => {
    navigate(routes.billingAccount.make(organization?.slug ?? ''));
  };

  const content = (
    <>
      <a
        onClick={(e) => {
          e.preventDefault();
          handleBillingAccountDetailsClick();
        }}
        href={routes.billingAccount.make(organization?.slug ?? '')}
        className="font-medium text-[var(--color-title)] hover:text-foreground-muted"
      >
        {organization?.billingAccount.name}
      </a>
      <p className="text-foreground-muted text-xs">{getPaymentInfo()}</p>
      <p className="text-foreground-muted text-xs">&nbsp;</p>
    </>
  );

  const actions = [{ label: 'Details', onClick: handleBillingAccountDetailsClick }];

  return <UniversalNoPictureCard content={content} actions={actions} />;
};
